import userType from "./userType";

export default [
  { id: userType.Regular, name: "Regular" },
  { id: userType.ApiKey, name: "Api Key" },
  { id: userType.Global, name: "Global" },
];
